<template>
  <div
    class="gl-analytics__disclaimer"
  >
    <gl-icon
      v-if="!isMobile && !isTablet"
      gray
      :height="14"
      :hover="false"
      name="info"
      :width="14"
    />
    All TMs indicated herein are for reference purposes only and in accordance with Art. 15 Swiss Trademark Protection Act.
  </div>
</template>
<script>
// Components
import GlIcon from '@/components/gl-icon.vue'
// Mixins
import deviceWidthMixin from '@/assets/mixins/deviceWidthMixin'
// Vuex
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    GlIcon
  },
  mixins: [ deviceWidthMixin ],
  computed: {
    ...mapState('analytics', ['rightToolbarState']),
    ...mapGetters('analytics', ['getOpenRightPanelState', 'getRightPanelWidthWithoutControls'])
  },
  mounted() {
    this.syncHeight()

    // The height is measured before Montserrat finishes loading, and the
    // fallback font wraps this text into fewer lines — on mobile that is a
    // 16px lie that everything anchored to --disclaimer-height inherits, so
    // the bottom toolbar ends up underneath the disclaimer. A resize event
    // never fires for a font swap; observing the element does.
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(this.syncHeight)
      this.resizeObserver.observe(this.$el)
    }
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
  },
  methods: {
    syncHeight() {
      const isShown = this.$route.name === 'analytics'

      document.documentElement.style.setProperty(
        '--disclaimer-height',
        `${isShown ? this.$el.clientHeight : 0}px`,
      )
    },
  },
}
</script>

<style>
.gl-analytics__disclaimer {
  display: flex;
  padding: 4px 5%;
  justify-content: center;
  align-items: center;
  gap: 6px;
  background: var(--white);
  box-shadow: 0 -4px 6px -4px rgba(0, 0, 0, 0.08);

  color: var(--Basic-800, rgba(9, 21, 64, 0.68));

  font-size: var(--Size-S, 12px);
  font-style: normal;
  font-weight: 500;
  line-height: var(--Line-Height-S, 16px);
  letter-spacing: var(--Letter-Spacing-None, 0px);
  text-align: center;
  //position: relative;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 10;
}
</style>

